<ngx-spinner
  [color]="primaryColor"
  [fullScreen] = "false"
  bdColor = "transparent"
  size = "default"
  type="ball-clip-rotate-multiple">
  <p style="font-size: 14px; color: white">Loading...</p>
</ngx-spinner>

<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="mobileQuery.matches ? 'over' : 'side'" [opened]="app.isAuthenticated && routerService.isAuthRoute()">
    <a routerLink="/dashboard" class="logo-link">
      <img src="./assets/images/logo.png" class="logo" alt="SiteSoft New Zealand Ltd" />
    </a>

    <mat-nav-list dense>

      <ng-container *ngIf="app.isAuthenticated; else notAuthenticated">
        <a mat-list-item routerLinkActive="active-submenu-item" routerLink="dashboard">
          <span class="menu-panel-text">Dashboard</span>
        </a>

        <a *ngIf="navCan.sites" mat-list-item routerLinkActive="active-submenu-item" routerLink="sites" >
          <span class="menu-panel-text"> {{ utils.getLangTerm('sites.plural', 'Sites') }} </span>
        </a>

        <a *ngIf="navCan.safetyPlans" mat-list-item routerLinkActive="active-submenu-item" routerLink="sssp">
          <span class="menu-panel-text">{{ utils.getLangTerm('safety-plans.plural', 'Safety Plans') }}</span>
        </a>

        <a *ngIf="navCan.contractors" mat-list-item routerLinkActive="active-submenu-item" routerLink="contractors">
          <span class="menu-panel-text">{{ utils.getLangTerm('contractors.plural', 'Contractors') }}</span>
        </a>

        <a *ngIf="navCan.employees" mat-list-item routerLinkActive="active-submenu-item" routerLink="employees">
          <span class="menu-panel-text">{{ utils.getLangTerm('employees.plural', 'Employees') }}</span>
          <!-- Pending membership requests (SC-301). Surfaced on the menu because somebody waiting on
               approval cannot work, and a queue only visited deliberately is a queue nobody empties.
               Never rendered at zero. -->
          @if(pendingAccessRequests > 0) {
            <span class="badge badge-warning ml-2"
                  matTooltip="{{ pendingAccessRequests }} request(s) to join this account are awaiting approval.">
              {{ pendingAccessRequests }}
            </span>
          }
        </a>

        <a *ngIf="navCan.tasks" mat-list-item routerLinkActive="active-submenu-item" routerLink="actions">
          <span class="menu-panel-text">Tasks</span>
        </a>

        <a *ngIf="navCan.accountInductions" mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['courses']">
          <span class="menu-panel-text">Account Inductions</span>
        </a>

        <mat-expansion-panel *ngIf="navCan.forms" class="mat-elevation-z">
          <mat-expansion-panel-header>
            <mat-panel-title id="dynamic-forms"><span class="submenu-panel-header">Forms</span></mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list dense>
            <a mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['dynamic-forms']">
              <span class="submenu-panel-text">Form Templates</span>
            </a>
            <a mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['dynamic-forms-categories']" >
              <span class="submenu-panel-text">Form Categories</span>
            </a>
            <a mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['dynamic-forms-assigned']">
              <span class="submenu-panel-text">Form Submissions</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="navCan.registers" class="mat-elevation-z">
          <mat-expansion-panel-header>
            <mat-panel-title id="registers"><span class="submenu-panel-header">Registers</span></mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list dense>
            <a *ngIf="navCan.registersIncidents" mat-list-item routerLinkActive="active-submenu-item" routerLink="incidents">
              <span class="submenu-panel-text">Incidents</span>
            </a>

            <a *ngIf="navCan.registersSafetyObservations" mat-list-item routerLinkActive="active-submenu-item" routerLink="safety-observations">
              <span class="submenu-panel-text">Safety Observations</span>
            </a>

            <a *ngIf="navCan.registersHazards" mat-list-item routerLinkActive="active-submenu-item" routerLink="hazards">
              <span class="submenu-panel-text">Hazards & Risks</span>
            </a>

            <a *ngIf="navCan.registersHazardousSubstances" mat-list-item routerLinkActive="active-submenu-item" routerLink="hazardous_substances">
              <span class="submenu-panel-text">{{ utils.getLangTerm('hazardous-substances.list.account-title', 'Hazardous Substances') }}</span>
            </a>

            <a *ngIf="navCan.registersInspectionsAudits" mat-list-item routerLinkActive="active-submenu-item" routerLink="audits">
              <span class="submenu-panel-text">Inspections & Audits</span>
            </a>

            <a *ngIf="navCan.registersToolboxTalks" mat-list-item routerLinkActive="active-submenu-item" routerLink="toolbox-talks">
              <span class="submenu-panel-text">{{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }}</span>
            </a>

            <a *ngIf="navCan.registersTools" mat-list-item routerLinkActive="active-submenu-item" routerLink="tools">
              <span class="submenu-panel-text">Tools</span>
            </a>

            <!-- Moved here from the former dedicated Assets menu. Kept adjacent and in their original
                 relative order, appended rather than interleaved so the existing register order is
                 undisturbed. Vendors is labelled "Asset Vendors" to match its siblings. -->
            <a *ngIf="navCan.registersAssets" mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['asset-register']">
              <span class="submenu-panel-text">Asset Register</span>
            </a>

            <a *ngIf="navCan.registersAssetTypes" mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['asset-types']">
              <span class="submenu-panel-text">Asset Types</span>
            </a>

            <a *ngIf="navCan.registersVendors" mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['vendors']">
              <span class="submenu-panel-text">Asset Vendors</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="navCan.templates" class="mat-elevation-z">
          <mat-expansion-panel-header>
            <mat-panel-title id="templates"><span class="submenu-panel-header">Templates</span></mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list dense>
            <a *ngIf="navCan.templatesTaskAnalysis" mat-list-item routerLinkActive="active-submenu-item" routerLink="task-analysis">
              <span class="submenu-panel-text">{{ utils.getLangTerm('task_analysis_documents.list.title', 'Task Analysis Documents') }} <i>(Legacy)</i></span>
            </a>

            <a *ngIf="navCan.templatesTaJsaSwms" mat-list-item routerLinkActive="active-submenu-item" routerLink="task-analyses-revised">
              <span class="submenu-panel-text">{{ utils.getLangTerm('ta-jsa-swms.list.account-title', 'TA/JSA/SWMS') }}</span>
            </a>

            <a *ngIf="navCan.templatesDocuments" mat-list-item routerLinkActive="active-submenu-item" routerLink="folders">
              <span class="submenu-panel-text">Documents</span>
            </a>

            <a *ngIf="navCan.templatesPreQualifications" mat-list-item routerLinkActive="active-submenu-item" routerLink="prequalifications" [routerLinkActiveOptions]="{ exact: true }">
              <span class="submenu-panel-text">{{ utils.getLangTerm('contractors.singular', 'Contractor') }} Pre-Qualifications</span>
            </a>

            <a *ngIf="navCan.templatesInspectionsAudits" mat-list-item routerLinkActive="active-submenu-item" routerLink="audits-templates">
              <span class="submenu-panel-text">Inspection/Audit Templates</span>
            </a>

            <a *ngIf="navCan.templatesInspectionsAudits" mat-list-item routerLinkActive="active-submenu-item" routerLink="audit-items-template">
              <span class="submenu-panel-text">Inspection/Audit Questions</span>
            </a>

            <a *ngIf="navCan.templatesToolboxTalks" mat-list-item routerLinkActive="active-submenu-item" routerLink="toolbox-talks-templates">
              <span class="submenu-panel-text">{{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }} Templates</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="navCan.reports" class="mat-elevation-z">
          <mat-expansion-panel-header>
            <mat-panel-title id="reports"><span class="submenu-panel-header">Reports</span></mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list dense>

            <ng-container *ngIf="navCan.reportsSiteAccess">
              <a mat-list-item routerLinkActive="active-submenu-item" routerLink="reports/access-records">
                <span class="submenu-panel-text">Sign In/Out</span>
              </a>

              <a mat-list-item routerLinkActive="active-submenu-item" routerLink="reports/onsite-records">
                <span class="submenu-panel-text">Currently Onsite</span>
              </a>

              <a mat-list-item routerLinkActive="active-submenu-item" routerLink="reports/time-onsite-records">
                <span class="submenu-panel-text">Time Spent Onsite</span>
              </a>
            </ng-container>

            <a *ngIf="navCan.reportsVisitors" mat-list-item routerLinkActive="active-submenu-item" routerLink="visitors">
              <span class="submenu-panel-text">Visitors</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <a *ngIf="navCan.messages" mat-list-item routerLinkActive="active-submenu-item" routerLink="messages">
          <span class="menu-panel-text">Messages</span>
        </a>

        <a *ngIf="navCan.clientSites" mat-list-item routerLinkActive="active-submenu-item" routerLink="user/accessible-sites">
          <span class="menu-panel-text">Client {{ utils.getLangTerm('sites.plural', 'Sites') }}</span>
        </a>

        <a *ngIf="navCan.clientPreQualifications" mat-list-item routerLinkActive="active-submenu-item" routerLink="my-prequalifications">
          <span class="menu-panel-text">Client Pre-Qualifications</span>
        </a>
      </ng-container>

      <ng-template #notAuthenticated>
        <a mat-list-item routerLinkActive="active-submenu-item" routerLink="sign-in">
          <span class="menu-panel-text">Login</span>
        </a>
      </ng-template>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-top-nav [sidenav]="sidenav"></app-top-nav>

    <!-- Pending membership banner (SC-301). Lives in the shell so it follows the user to whatever page
         they land on. Without it, being signed in while unable to see the account they asked to join is
         indistinguishable from the product being broken. -->
    @if(ownPendingRequest) {
      <div class="alert alert-info m-2 mb-0" role="status">
        <mat-icon class="align-middle mr-2">hourglass_empty</mat-icon>
        @if(ownPendingCount > 1) {
          You have <b>{{ ownPendingCount }}</b> requests awaiting approval.
        } @else {
          Your request to join <b>{{ ownPendingRequest.account_name }}</b> is awaiting approval.
        }
        <a routerLink="/user/account-access" class="ml-2">View status</a>
      </div>
    }

    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-modal></app-modal>
<app-toast></app-toast>

<!-- toggleable overlay with a spinner -->
<tour-step-template></tour-step-template>
